<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {
            isRouterAlive: true
        }
    },
    methods: {

    },
    created() {
        // console.log('sessionStorage', typeof sessionStorage, sessionStorage);
        this.$toast.allowMultiple()

        var ip = this.$tool.data.get('clientip');
        // console.log('ip', ip);
        if (!ip) {
            this.$api.post('index/ajax/getClientIp', {}, {
                ws: false
            }).then((res) => {
                if (res.code == 200) {
                    this.$tool.data.set('clientip', res.data.ip);
                } else {
                    this.$toast.fail('服务器请错误，请联系网站管理员处理=>' + res.message)
                }
            }).catch((err) => {
                console.log(err);
            });

        }

        var loading = this.$tool.cookie.get('config.loading');
        if (!loading) {
            this.$api.post('index/store/h5/index/getConfig')
                .then((res) => {
                    if (res.code == 200) {
                        this.$tool.cookie.set('config.loading', true, 86400);
                        this.$tool.data.set('config', res.data);
                    } else {
                        this.$toast.fail('页面配置加载失败，' + res.message)
                    }
                }).catch((err) => {
                    console.log(err);
                });

        }


    }
}
</script>



// WEBPACK FOOTER //
// src/App.vue